__turbopack_context__.v({
  "container": "FeatureCard-module-scss-module__SA8ucG__container",
  "description": "FeatureCard-module-scss-module__SA8ucG__description",
  "imageWrapper": "FeatureCard-module-scss-module__SA8ucG__imageWrapper",
  "left": "FeatureCard-module-scss-module__SA8ucG__left",
  "right": "FeatureCard-module-scss-module__SA8ucG__right",
  "title": "FeatureCard-module-scss-module__SA8ucG__title",
});
